module.exports = __webpack_public_path__ + "img/avatar-farmacias-yza.png";